export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10532.3d7d8a4e.jpg";